module.exports = __webpack_public_path__ + "static/media/icon-cocktail.8c89dd40.svg";